import { render, staticRenderFns } from "./OrderCard.vue?vue&type=template&id=a878042e"
import script from "./OrderCard.vue?vue&type=script&lang=js"
export * from "./OrderCard.vue?vue&type=script&lang=js"
import style0 from "./OrderCard.vue?vue&type=style&index=0&id=a878042e&prod&media=print&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports